import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryParams, StringParam } from "use-query-params";
import Cookies from "js-cookie";
import { useResponsive } from "hooks/useResponsive";

// Components
import { default as Loadable } from "components/_Shared/commonLoadable";
import { SignUpForm } from "pages/signup/SignUpForm/";
import { SocialButtons } from "pages/Login/SocialButtons";
import { CaptchaDisclaimer } from "components/CaptchaDisclaimer";
import { Divider } from "components/spocketUI/";
import { TopContainerLogin } from "components/TopContainerLogin";

// Actions
import { clearCredentialStorage, deregister, signOut } from "utils/actions";

// Utils
import { formatUtm } from "utils/utm";
import { gaEvent } from "utils/trackEvents";

// Style
import "../../index.css"; // TODO We need to change our base CSS to remove bloat and use Styled-Components
import {
  SignupContainer,
  ContentContainer,
  FormContainer,
  IntroTextContainer,
  IntroTextBold,
  HorizontalDividerContainer,
  IntroTextSubtitle
} from "pages/Login/style";
import { isEmpty } from "lodash";

const REGEX_GET_EMAIL = /(?:&|\?)email=([^&]+)/;

const decodeEmailFromUrl = urlParam => {
  const email = decodeURIComponent(encodeURIComponent(urlParam));
  return email.replace(/%40/g, "@");
};

export const Signup = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [query] = useQueryParams({
    id: StringParam
  });
  const fullURL = window.location.href;
  const emailOnURL = fullURL.match(REGEX_GET_EMAIL);

  const queryEmail = !isEmpty(emailOnURL) && emailOnURL.length > 0 ? decodeEmailFromUrl(emailOnURL[1]) : "";
  const { id: queryId } = query;
  const hasQueryEmail = queryEmail !== undefined && queryEmail.length > 0;
  const { isPhone } = useResponsive();
  const [isFormActive, setIsFormActive] = useState(false);

  useEffect(() => {
    document.title = t("Signup.PageTitle");
    const spocketUtm = Cookies.get("spocket_utm");
    const formattedSpocketUtm = spocketUtm ? formatUtm(spocketUtm) : {};

    if (Object.keys(formattedSpocketUtm).length === 0) {
      Cookies.set("spocket_utm", window.location.search, {
        expires: 30,
        domain: ".spocket.co",
        path: "/"
      });
    }
    if (queryEmail) {
      localStorage.setItem("landing_page_signup", "variant");
    } else if (queryId) {
      localStorage.setItem("landing_page_signup", "control");
    } else if (!queryEmail && !queryId) {
      localStorage.setItem("landing_page_signup", "notIncluded");
    }

    const queryParams = new URLSearchParams(window.location.search);
    const jsonQeryParams = JSON.stringify(Object.fromEntries(queryParams));
    localStorage.setItem("signup_query_params", jsonQeryParams);

    // Clear user data on storage
    clearCredentialStorage();
    deregister();
    signOut();
  }, []);

  useEffect(() => {
    if (hasQueryEmail) {
      gaEvent({
        category: "Sign Up Error",
        action: "Direct Sign Up"
      });
      setIsLoading(true);
    }
  }, [queryEmail]);

  return (
    <Loadable active={isLoading} spinnerSize="10px">
      <SignupContainer>
        <TopContainerLogin />
        <ContentContainer>
          <IntroTextContainer>
            <IntroTextBold>{t("Signup.SignUpForm.IntroTextBold")}</IntroTextBold>
            <IntroTextSubtitle>{t("Signup.SignUpForm.IntroTextBold.Subtitle")}</IntroTextSubtitle>
          </IntroTextContainer>

          <FormContainer isFormActive={isFormActive}>
            <SocialButtons isFormActive={isFormActive} isPhone={isPhone} type="signup" />

            <HorizontalDividerContainer>
              <Divider>{t("Login.Divider.Mobile")}</Divider>
            </HorizontalDividerContainer>

            <SignUpForm
              setIsLoading={setIsLoading}
              queryEmail={queryEmail}
              isFormActive
              isPhone={isPhone}
              onFocusForm={() => setIsFormActive(true)}
            />
          </FormContainer>

          <CaptchaDisclaimer isFormActive={isFormActive} />
        </ContentContainer>
      </SignupContainer>
    </Loadable>
  );
};
